import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from 'components/Button/Button';
import Select from 'components/form/Select';
import {
  getDeviceSelectionOptions,
  getDeviceSettings,
} from 'hooks/useMediaRecorder';
import React, { useState, useEffect } from 'react';

const mapOptions = (options) =>
  options.map((i) => ({
    label: i.label,
    value: i.deviceId,
  }));

const VideoSettingsModal = ({ onClose, onSubmit }) => {
  const [settings, setSettings] = useState({
    audioinput: 'default',
    audiooutput: 'default',
    videoinput: 'default',
  });
  const [devices, setDevices] = useState({
    audioinput: [],
    audiooutput: [],
    videoinput: [],
  });

  useEffect(() => {
    getDeviceSelectionOptions().then((resp) => {
      setDevices(resp);
      const s = getDeviceSettings();
      if (!s) {
        setSettings({
          videoinput: resp.videoinput[0]?.deviceId,
          audioinput: resp.audioinput[0]?.deviceId,
        });
      } else {
        setSettings(s);
      }
    });
  }, []);

  const onSave = () => {
    onSubmit(settings);
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Settings</DialogTitle>
      <DialogContent>
        <Select
          fullWidth
          isMulti={false}
          transformValue
          label="Camera"
          options={mapOptions(devices.videoinput)}
          value={settings.videoinput}
          onChange={(val) => setSettings({ ...settings, videoinput: val })}
        />
        <Select
          fullWidth
          isMulti={false}
          transformValue
          menuPlacement="top"
          label="Microphone"
          options={mapOptions(devices.audioinput)}
          value={settings.audioinput}
          onChange={(val) => setSettings({ ...settings, audioinput: val })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onSave}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VideoSettingsModal;
